import { render, staticRenderFns } from "./AlarmsDetail.vue?vue&type=template&id=5ef448d2&scoped=true&"
import script from "./AlarmsDetail.vue?vue&type=script&lang=js&"
export * from "./AlarmsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsDetail.vue?vue&type=style&index=0&id=5ef448d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef448d2",
  null
  
)

export default component.exports